import SvgIcon from "../../../../../components/SvgIcon/SvgIcon";

interface Props {
  title: string;
  description: string;
  iconKey?: any;
}

const SearchSelectionCardHeader = ({
  title,
  description,
  iconKey = "search",
}: Props) => {
  return (
    <div className="border-b border-stroke px-6 py-5 dark:border-strokedark">
      <div className="flex items-start gap-4">
        {/* Icon */}
        <div
          className="
            flex h-11 w-11 items-center justify-center
            rounded-md
            bg-primary bg-opacity-10
            text-primary
            dark:bg-primary dark:bg-opacity-20
          "
        >
          <SvgIcon name={iconKey} />
        </div>

        {/* Content */}
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-black dark:text-white">
            {title}
          </h3>

          <p className="mt-1 text-sm leading-relaxed text-body dark:text-bodydark">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SearchSelectionCardHeader;